export const headerConstants = {
  resources: [
    {
      title: "Public Policy Meetings",
      link: "/meetingdates",
      permission: "MeetingDates: View",
    },
  ],
  tools: [
    {
      title: "Groupings",
      link: "/groupings",
      permission: "Groupings: View",
    },
    {
      title: "Highlighter",
      link: "/highlighter",
      permission: "Intranet",
    },
    {
      title: "StateScape AI",
      link: "/aitool",
      permission: "Intranet",
    },
    {
      title: "Legislative Sessions",
      link: "/legsessions",
      permission: "Intranet",
    },
  ],
  clientTools: [],
};



// WEBPACK FOOTER //
// ./src/components/Header/constants.js